import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import { Button } from 'react-bootstrap';
import TrialLicenseDisplay from 'software_renewal/components/TrialLicenseDisplay';
import { useDispatch, useSelector } from 'react-redux';
import { resetSerialNumber } from 'software_renewal/redux/slice';
import {
  dataForLicenseDisplay,
  selectSerialNumberLoaded,
} from 'software_renewal/redux/selectors';

const LicenseDisplay = () => {
  const dispatch = useDispatch();
  const licenseInfo = useSelector(dataForLicenseDisplay);
  const serialNumberLoaded = useSelector(selectSerialNumberLoaded);

  useEffect(() => {
    if (serialNumberLoaded) {
      $(`.license-display`).collapse('show');
      $(`.software-features`).addClass('d-none');
    } else {
      $(`.license-display`).collapse('hide');
    }
  }, [serialNumberLoaded]);

  if (!licenseInfo) {
    return null;
  }

  const onResetSerialNumber = () => {
    dispatch(resetSerialNumber());
    $(`.software-features`).removeClass('d-none');
  };

  const {
    serialNumber,
    expirationDate,
    customerName,
    licenseSpan,
    evaluationVersion,
    displayOptionValues,
  } = licenseInfo;

  const expired = dayjs().isAfter(dayjs(expirationDate));

  if (evaluationVersion) {
    return (
      <div className="license-display collapse">
        <TrialLicenseDisplay licenseInfo={licenseInfo} />
        <div className="mt-4 try-again">
          This is not the license you want to renew?
          <Button
            variant="link"
            className="px-1 py-0"
            onClick={onResetSerialNumber}
          >
            Try another one
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="license-display collapse h-100">
      <div className="card p-4 mb-3 h-100">
        <table>
          <thead>
            <tr>
              <td colSpan={2} className="title p-0">
                About serial {serialNumber}
                <hr />
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="table-header">
                Customer Name:
              </td>
              <td>
                {customerName}
              </td>
            </tr>
            <tr>
              <td className="table-header py-1 d-block">
                Product:
              </td>
              <td>
                {displayOptionValues.productName}<br />
                {displayOptionValues.licenseType} {displayOptionValues.activationMethod} <br />
                {displayOptionValues.numberOfUsers}
              </td>
            </tr>
            <tr>
              <td className="table-header py-1">
                Subscription Period
              </td>
              <td>
                {displayOptionValues.licenseSpan}
              </td>
            </tr>
            <tr>
              <td className="table-header py-1">
                {licenseSpan === 'perpetual' ? <>Maintenance <br />Expiration Date</> : 'Valid Through'}
              </td>
              <td>
                {dayjs(expirationDate).format('MMMM DD, YYYY')}
              </td>
            </tr>
          </tbody>
        </table>
        <div className="mt-auto">
          {expired && (
            <div className="mt-3 note text-danger">
              Technical support and updates for this license have expired and are no longer available.
            </div>
          )}
          <div className="mt-2 try-again">
            This is not the license you want to renew?
            <Button
              variant="link"
              className="px-1 py-0"
              onClick={onResetSerialNumber}
            >
              Try another one
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LicenseDisplay;
